// Display labels shared by the resource / vendor / engagement detail pages.

export const COMPANY_LABELS: Record<string, string> = {
  LLC: 'LLC',
  C_CORP: 'C-Corp',
  S_CORP: 'S-Corp',
};

export const DOC_LABELS: Record<string, string> = {
  w9: 'W-9',
  coi: 'Certificate of Insurance',
  voided_check: 'Voided check',
  visa: 'Visa documentation',
  cert_of_incorporation: 'Certificate of Incorporation',
  driver_license: "Driver's license",
  resume: 'Résumé',
  signed_contract: 'Signed contract',
  contract_template: 'Contract template',
  other: 'Other',
};
